import { Model } from './shape/shape'
import ImageWidget from './image/image'
import Speedometer from './speedometer/speedometer'
import LinearGauge from './linear-gauge/linear-gauge'
import ChartTableModel from 'scoreboard/dashboards/widgets/chart/config/chart-table-model'
import ChartColorLegendModel from 'scoreboard/dashboards/widgets/chart/config/chart-color-legend-model'
import NotesWidget from './notes/notes'
import ReportWidget from './report/report-widget'
import TextWidget from './text/text-widget'
import InitiativeChart from './initiative-chart/initiative-chart'
import Perspective from './perspective/perspective'
import DatasetFilter from './dataset-filter/dataset-filter-widget'
import DatasetTable from './dataset-table/dataset-table-widget'
import EmbeddedContent from './embedded-content/embedded-content'
import InitiativeTimeline from './initiative-timeline/initiative-timeline-widget'
import ChartWidgetModel from 'scoreboard/dashboards/widgets/chart/chart-widget-model'

var AllDashboardWidgets = {
	'shape': Model,
	'image': ImageWidget.Model,
	'speedometer': Speedometer.Model,
	'linear-gauge': LinearGauge.Model,
	'chart': ChartWidgetModel,
	'chart-table': ChartTableModel,
	'chart-color-legend': ChartColorLegendModel,
	'dataset-filter': DatasetFilter.Model,
	'dataset-table': DatasetTable.Model,
	'embedded-content': EmbeddedContent.Model,
	'initiative-chart': InitiativeChart.Model,
	'initiative-timeline': InitiativeTimeline.Model,
	'notes': NotesWidget.Model,
	'report': ReportWidget.Model,
	'text': TextWidget.Model,
	'perspective': Perspective.Model
}

export default AllDashboardWidgets

AllDashboardWidgets.__filename__ = 'dashboards/widgets/all.js'
